var map = {
	"./ai.svg": "3318",
	"./avi.svg": "31ee",
	"./css.svg": "7f0c",
	"./csv.svg": "8469",
	"./dbf.svg": "8078",
	"./doc.svg": "0292",
	"./dwg.svg": "708f",
	"./exe.svg": "99da",
	"./file.svg": "55f5",
	"./fla.svg": "f512",
	"./html.svg": "f2d3",
	"./iso.svg": "ba41",
	"./jpg.svg": "d733",
	"./js.svg": "27d5",
	"./json.svg": "0686",
	"./mp3.svg": "2bab",
	"./mp4.svg": "4354",
	"./pdf.svg": "653a",
	"./png.svg": "e071",
	"./ppt.svg": "bba1",
	"./psd.svg": "0017",
	"./rtf.svg": "dcc3",
	"./search.svg": "be99",
	"./svg.svg": "0e47",
	"./txt.svg": "94ef",
	"./xls.svg": "d9f6",
	"./xml.svg": "3dc4",
	"./zip.svg": "c935"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "541c";